import React, { lazy } from 'react'
import { Route } from 'react-router-dom'
import { lazyWithPreload } from './lazy-with-preload'

// Exported so `route-preload` can start this chunk while sign-in is still
// resolving — it is where all but a handful of sign-ins land.
export const Dashboard = lazyWithPreload(() => import('../modules/Dashboard'))
const ProjectWizard = lazy(() => import('../modules/ProjectWizard'))

export const dashboardRoutes = [
  <Route key='dashboard' path='/dashboard' element={<Dashboard />} />,
  <Route key='project-wizard' path='/projects/new' element={<ProjectWizard />} />
]
